import useSession from '../../hooks/useSession';
import { Link } from 'react-router-dom'
const Landing = () => {
  const [session] = useSession()
  return (
    <section className="landing">
      <div className="dark-overlay">
        <div className="landing-inner">
          <h1 className="x-large">Bunny widget</h1>
          <p className="lead">
            This is a test as a user of the bunny widget
          </p>
          <div className="buttons">
            {session ?
              (<Link to="/widget#project" className="btn btn-primary">Create a project</Link>) :
              (<>
                <Link to="/register" className="btn btn-primary">Sign Up</Link>
                <Link to="/login" className="btn btn-light">Login</Link>
              </>)
            }
          </div>
        </div>
      </div>
    </section>
  )
}

export default Landing